var _style, _path, _ellipse, _ellipse2, _path2, _path3, _rect, _rect2, _rect3, _path4, _ellipse3, _ellipse4, _ellipse5, _rect4, _path5, _g, _rect5, _path6, _path7, _path8, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _rect12, _rect13, _g2, _g3, _g4, _g5, _rect14, _ellipse6, _ellipse7, _ellipse8, _ellipse9, _ellipse10, _ellipse11, _ellipse12, _ellipse13, _ellipse14, _ellipse15, _ellipse16, _ellipse17, _ellipse18, _ellipse19, _ellipse20, _ellipse21, _ellipse22, _ellipse23, _ellipse24, _ellipse25, _ellipse26, _path18, _ellipse27, _ellipse28, _path19, _ellipse29, _polygon, _ellipse30, _ellipse31, _ellipse32, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _ellipse33, _ellipse34, _ellipse35, _rect15, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _ellipse36, _path42, _rect16, _ellipse37, _path43, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _path44, _rect23, _g6, _g7, _g8, _g9, _rect24, _rect25, _rect26, _rect27, _path45, _path46, _rect28, _ellipse38, _ellipse39, _ellipse40, _ellipse41, _ellipse42, _ellipse43, _ellipse44, _ellipse45, _ellipse46, _ellipse47, _ellipse48, _ellipse49, _ellipse50, _ellipse51, _ellipse52, _ellipse53, _ellipse54, _ellipse55, _ellipse56, _ellipse57, _ellipse58, _path47, _ellipse59, _ellipse60, _ellipse61, _path48, _ellipse62, _polygon2, _ellipse63, _ellipse64, _ellipse65, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _ellipse66, _ellipse67, _rect29, _path62, _path63, _path64, _path65, _path66, _path67, _path68;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReyHilt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lag_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 35 200",
    style: {
      enableBackground: "new 0 0 35 200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0rsh{fill:#575656;}\r\n\t.st1rsh{fill:#202020;}\r\n\t.st2rsh{fill:#333333;}\r\n\t.st3rsh{fill:#474646;}\r\n\t.st4rsh{fill:#575656;stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;}\r\n\t.st5rsh{fill:#585656;}\r\n\t.st6rsh{fill:#BFAF8C;}\r\n\t.st7rsh{fill:#6C6B6B;}\r\n\t.st8rsh{fill:#3F3E3E;}\r\n\t.st9rsh{fill:#4D4B4B;}\r\n\t.st10rsh{fill:#53514F;}\r\n\t.st11rsh{fill:#5F5F5E;stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;}\r\n\t.st12rsh{fill:#7C7C7C;}\r\n\t.st13rsh{fill:none;stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;}\r\n\t.st14rsh{fill:#1C1C1C;}\r\n\t.st15rsh{fill:#61615F;}\r\n\t.st16rsh{fill:#555454;}\r\n\t.st17rsh{fill:#676766;}\r\n\t.st18rsh{fill:#52514F;}\r\n\t.st19rsh{fill:#565454;}\r\n\t.st20rsh{fill:#626260;}\r\n\t.st21rsh{fill:#686867;}\r\n\t.st22rsh{fill:#5E4D2C;}\r\n\t.st23rsh{fill:#685534;}\r\n\t.st24rsh{fill:#765A4B;}\r\n\t.st25rsh{fill:#775B4C;}\r\n\t.st26rsh{fill:#7A6962;}\r\n\t.st27rsh{fill:#696969;}\r\n\t.st28rsh{fill:#8B8B8C;}\r\n\t.st29rsh{fill:#717070;}\r\n\t.st30rsh{fill:#696C6C;}\r\n\t.st31rsh{fill:#636464;}\r\n\t.st32rsh{fill:#888989;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0rsh",
    d: "M28.7,27.2H7.4c-0.9,0-1.6-0.7-1.6-1.6v-4.9c0-0.9,0.7-1.6,1.6-1.6h21.3c0.9,0,1.6,0.7,1.6,1.6v4.9 C30.3,26.5,29.6,27.2,28.7,27.2z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "st1rsh",
    cx: 11.4,
    cy: 20.6,
    rx: 0.4,
    ry: 0.6
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st1rsh",
    cx: 28.4,
    cy: 20.7,
    rx: 0.3,
    ry: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1rsh",
    d: "M27.8,24.9H12.2c-0.3,0-0.6-0.3-0.6-0.6v-0.6c0-0.3,0.3-0.6,0.6-0.6h15.6c0.3,0,0.6,0.3,0.6,0.6v0.6 C28.4,24.6,28.1,24.9,27.8,24.9z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2rsh",
    d: "M28,19.5H8.3c-0.4,0-0.7-0.3-0.7-0.8v-3.9c0-0.4,0.3-0.8,0.7-0.8H28c0.4,0,0.8,0.3,0.8,0.8v3.9 C28.8,19.1,28.4,19.5,28,19.5z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.6,
    y: 12.8,
    className: "st1rsh",
    width: 19,
    height: 1.4
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8.1,
    y: 8,
    className: "st2rsh",
    width: 20,
    height: 4.8
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 10.2,
    y: 4,
    className: "st2rsh",
    width: 15.7,
    height: 4.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st2rsh",
    d: "M14.9,0c2.1,0,4.3,0,6.4,0c0.7,0.5,1.5,1,2.3,1.8c0.9,0.8,1.6,1.5,2.3,2.2c-3.3,0.1-6.6,0.2-9.9,0.3 C14,4.2,12.1,4.1,10.2,4c0.6-0.7,1.4-1.6,2.4-2.4C13.4,0.9,14.2,0.4,14.9,0z"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st1rsh",
    cx: 17.7,
    cy: 0.5,
    rx: 0.5,
    ry: 0.3
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.6728 -0.7399 0.7399 0.6728 4.2854 11.015)",
    className: "st1rsh",
    cx: 14.6,
    cy: 0.7,
    rx: 0.3,
    ry: 0.2
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8098 -0.5867 0.5867 0.8098 3.7158 12.4365)",
    className: "st1rsh",
    cx: 21,
    cy: 0.5,
    rx: 0.2,
    ry: 0.3
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 9.4,
    y: 145.9,
    className: "st3rsh",
    width: 18.4,
    height: 1.8
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0rsh",
    d: "M7.2,134.8c-0.4,0.6-0.8,1.1-1.2,1.7c1,3.2,1.9,6.4,2.9,9.6c6.4,0,12.8,0,19.2,0c1-3.1,2.1-6.2,3.1-9.3 c-0.5-0.7-1-1.4-1.4-2.1C22.3,134.8,14.8,134.8,7.2,134.8z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4rsh",
    d: "M15.3,140.8c-0.4,0.8-0.1,1.8,0.6,2.2l1.4-2.8C16.6,139.7,15.7,140,15.3,140.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4rsh",
    d: "M18.1,142.5c0.4-0.8,0.1-1.8-0.6-2.2l-1.4,2.8C16.9,143.6,17.8,143.3,18.1,142.5z"
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 8.5,
    y: 69,
    className: "st3rsh",
    width: 20.2,
    height: 1.8
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st5rsh",
    d: "M8,87.7c-0.6-1.2-1.3-2.3-1.9-3.5c0.6-4.7,1.3-9.4,1.9-14.1c7.1,0,14.2,0,21.3,0c0.6,4.7,1.2,9.3,1.8,14 c-1,1.6-1.9,3.2-2.9,4.8C21.5,88.5,14.8,88.1,8,87.7z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st6rsh",
    d: "M7.7,98.3c0-0.8,0-1.9,0-3.2c0-4.2-0.1-4.6-0.3-5c-0.2-0.5-0.8-1.4-1.3-2.7C6.1,87.3,6,87.1,6,87 c0.1-0.5,1.1-0.3,1.8-0.1c0.6,0.2,1,0.2,1.4,0.1c0.2-0.1,0.3-0.2,0.5-0.2c0.5-0.2,1-0.1,1.4,0c0.1-0.2,0.3-0.4,0.6-0.5 c0.3-0.1,0.4,0,0.7,0.1c0.6,0.2,0.7,0,1.4,0.2c0.8,0.2,0.7,0.4,1.2,0.4c0.8,0,1-0.6,1.8-0.6c0.5,0,0.5,0.3,1.2,0.4 c0.9,0.2,1-0.3,1.8-0.2c1.1,0.1,1.4,0.9,2.2,0.5c0.3-0.1,0.4-0.3,0.7-0.6c0.2-0.2,1.1-0.9,4,0.1c0.7,0.2,1.6,0.6,2.6,1.1 c0.2,0.4,0.6,0.9,0.5,1.6c0,0.7-0.4,0.9-0.7,1.7c-0.2,0.7-0.1,1.4,0,2.9c0.1,0.8,0.2,1.9,0.4,3.2c-0.9-0.2-1.8-0.3-2.8-0.4 C19.8,95.8,13.3,96.6,7.7,98.3z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st6rsh",
    d: "M29.3,127.7c0,0.6,0,1.4,0,2.4c0,3.2,0.1,3.5,0.3,3.8c0.2,0.3,0.8,1.1,1.3,2c0,0.1,0.1,0.2,0.1,0.4 c-0.1,0.4-1.1,0.2-1.8,0.1c-0.6-0.2-1.1-0.1-1.4-0.1c-0.2,0.1-0.3,0.1-0.5,0.2c-0.5,0.1-1,0.1-1.4,0c-0.1,0.1-0.3,0.3-0.6,0.4 c-0.3,0.1-0.5,0-0.7-0.1c-0.6-0.2-0.7,0-1.4-0.1c-0.8-0.1-0.7-0.3-1.2-0.3c-0.8,0-1,0.5-1.8,0.5c-0.5,0-0.5-0.2-1.2-0.3 c-0.9-0.1-1,0.2-1.8,0.1c-1.1-0.1-1.5-0.7-2.3-0.4c-0.3,0.1-0.4,0.3-0.7,0.4c-0.2,0.2-1.1,0.6-4-0.1c-0.7-0.2-1.6-0.4-2.6-0.8 c-0.2-0.3-0.6-0.7-0.5-1.2c0-0.5,0.4-0.7,0.7-1.3c0.2-0.5,0.1-1.1,0-2.2c-0.1-0.6-0.2-1.4-0.4-2.4C8,128.9,9,129,9.9,129 C17,129.6,23.6,129,29.3,127.7z"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 28.7,
    y: 66,
    className: "st7rsh",
    width: 0.9,
    height: 0.8
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 28.3,
    y: 66.3,
    className: "st7rsh",
    width: 0.7,
    height: 1.2
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 28.7,
    y: 67.1,
    className: "st7rsh",
    width: 0.9,
    height: 1
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 7.4,
    y: 67.1,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 15.6368 135.0106)",
    className: "st7rsh",
    width: 0.9,
    height: 0.8
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 66.4,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 16.7415 134.0102)",
    className: "st7rsh",
    width: 0.7,
    height: 1.2
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 7.4,
    y: 65.9,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 15.6368 132.7714)",
    className: "st7rsh",
    width: 0.9,
    height: 1
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st8rsh",
    d: "M8.7,69.3C8.5,69.1,8.3,69,8,68.8c0.2-1.4,0.5-2.8,0.7-4.2c0-0.8,0-1.6,0-2.4c2.9,0.1,5.8,0.1,8.8,0.2 c3.7,0,7.3,0,10.8,0c0,0.7,0,1.4,0,2.1c0.2,1.4,0.4,2.7,0.7,4.1c-0.2,0.3-0.4,0.6-0.6,0.9C21.8,69.5,15.3,69.4,8.7,69.3z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st9rsh",
    d: "M18.1,68L18.1,68c-0.2,0-0.3-0.1-0.3-0.3v-2.6c0-0.2,0.1-0.3,0.3-0.3h0c0.2,0,0.3,0.1,0.3,0.3v2.6 C18.4,67.8,18.3,68,18.1,68z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st9rsh",
    d: "M22.1,68L22.1,68c-0.2,0-0.3-0.1-0.3-0.3v-2.6c0-0.2,0.1-0.3,0.3-0.3l0,0c0.2,0,0.3,0.1,0.3,0.3v2.6 C22.4,67.8,22.3,68,22.1,68z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st8rsh",
    d: "M27.7,62.4H9.4c-0.7,0-1.2-0.5-1.2-1.2v-0.5c0-0.7,0.5-1.2,1.2-1.2h18.4c0.7,0,1.2,0.5,1.2,1.2v0.5 C28.9,61.9,28.4,62.4,27.7,62.4z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st9rsh",
    d: "M25.7,68L25.7,68c-0.2,0-0.3-0.1-0.3-0.3l-0.3-2.5c0-0.2,0.1-0.3,0.2-0.3l0,0c0.2,0,0.3,0.1,0.3,0.3l0.3,2.5 C25.9,67.8,25.8,67.9,25.7,68z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st9rsh",
    d: "M14.3,68L14.3,68c-0.2,0-0.3-0.1-0.3-0.3v-2.6c0-0.2,0.1-0.3,0.3-0.3h0c0.2,0,0.3,0.1,0.3,0.3v2.6 C14.6,67.8,14.4,68,14.3,68z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st9rsh",
    d: "M10.9,68L10.9,68c-0.2,0-0.3-0.2-0.2-0.3l0.2-2.5c0-0.2,0.2-0.3,0.3-0.3l0,0c0.2,0,0.3,0.2,0.2,0.3l-0.2,2.5 C11.2,67.8,11,68,10.9,68z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st9rsh",
    d: "M8.9,67.9L8.9,67.9c0.1,0,0.1,0,0.1-0.1l0.2-2.6c0-0.1,0-0.1-0.1-0.1l0,0c-0.1,0-0.1,0-0.1,0.1l-0.2,2.6 C8.8,67.8,8.8,67.9,8.9,67.9z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st9rsh",
    d: "M27.9,67.8L27.9,67.8c0.1,0,0.1-0.1,0.1-0.1l-0.3-2.6c0-0.1-0.1-0.1-0.1-0.1l0,0c-0.1,0-0.1,0.1-0.1,0.1 l0.3,2.6C27.8,67.8,27.9,67.8,27.9,67.8z"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 3.2,
    y: 55.7,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 35.1236 115.2076)",
    className: "st0rsh",
    width: 28.8,
    height: 3.7
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 8.5,
    y: 58.9,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 35.1784 120.4794)",
    className: "st0rsh",
    width: 18.3,
    height: 2.7
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2rsh",
    d: "M29.5,60c0.6,0,1-0.3,1-0.6h-2C28.5,59.8,28.9,60,29.5,60z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2rsh",
    d: "M23.3,60c0.6,0,1-0.3,1-0.6h-2C22.2,59.8,22.7,60,23.3,60z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2rsh",
    d: "M13.2,60.1c0.6,0,1-0.3,1-0.6h-2C12.2,59.8,12.6,60.1,13.2,60.1z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2rsh",
    d: "M5.9,60.1c0.6,0,1-0.3,1-0.6h-2C4.9,59.8,5.4,60.1,5.9,60.1z"
  }))), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 5.7,
    y: 48.6,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 35.6612 101.6934)",
    className: "st10rsh",
    width: 24.3,
    height: 4.5
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st11rsh",
    cx: 22.6,
    cy: 52.4,
    rx: 1.3,
    ry: 0.2
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st11rsh",
    cx: 22.6,
    cy: 51.9,
    rx: 1.3,
    ry: 0.2
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st11rsh",
    cx: 22.6,
    cy: 51.4,
    rx: 1.3,
    ry: 0.2
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st11rsh",
    cx: 22.6,
    cy: 50.9,
    rx: 1.3,
    ry: 0.2
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st11rsh",
    cx: 22.6,
    cy: 50.4,
    rx: 1.3,
    ry: 0.2
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st11rsh",
    cx: 22.6,
    cy: 50,
    rx: 1.3,
    ry: 0.2
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st11rsh",
    cx: 22.6,
    cy: 49.5,
    rx: 1.3,
    ry: 0.2
  })), _ellipse13 || (_ellipse13 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st11rsh",
    cx: 13.6,
    cy: 52.4,
    rx: 1.3,
    ry: 0.2
  })), _ellipse14 || (_ellipse14 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st11rsh",
    cx: 13.6,
    cy: 51.9,
    rx: 1.3,
    ry: 0.2
  })), _ellipse15 || (_ellipse15 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st11rsh",
    cx: 13.6,
    cy: 51.4,
    rx: 1.3,
    ry: 0.2
  })), _ellipse16 || (_ellipse16 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st11rsh",
    cx: 13.6,
    cy: 50.9,
    rx: 1.3,
    ry: 0.2
  })), _ellipse17 || (_ellipse17 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st11rsh",
    cx: 13.6,
    cy: 50.4,
    rx: 1.3,
    ry: 0.2
  })), _ellipse18 || (_ellipse18 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st11rsh",
    cx: 13.6,
    cy: 50,
    rx: 1.3,
    ry: 0.2
  })), _ellipse19 || (_ellipse19 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st11rsh",
    cx: 13.6,
    cy: 49.5,
    rx: 1.3,
    ry: 0.2
  })), _ellipse20 || (_ellipse20 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st11rsh",
    cx: 6.8,
    cy: 52.4,
    rx: 1.3,
    ry: 0.2
  })), _ellipse21 || (_ellipse21 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st11rsh",
    cx: 6.8,
    cy: 51.9,
    rx: 1.3,
    ry: 0.2
  })), _ellipse22 || (_ellipse22 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st11rsh",
    cx: 6.8,
    cy: 51.4,
    rx: 1.3,
    ry: 0.2
  })), _ellipse23 || (_ellipse23 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st11rsh",
    cx: 6.8,
    cy: 50.9,
    rx: 1.3,
    ry: 0.2
  })), _ellipse24 || (_ellipse24 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st11rsh",
    cx: 6.8,
    cy: 50.4,
    rx: 1.3,
    ry: 0.2
  })), _ellipse25 || (_ellipse25 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st11rsh",
    cx: 6.8,
    cy: 50,
    rx: 1.3,
    ry: 0.2
  })), _ellipse26 || (_ellipse26 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st11rsh",
    cx: 6.8,
    cy: 49.4,
    rx: 1.3,
    ry: 0.2
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st0rsh",
    d: "M30.9,56.2c0.7,0.1,1.5,0.1,2.2,0.2c0.4-0.4,0.7-0.9,1.1-1.3c-1.3-7-2.6-14.1-4-21.1c-0.7-0.7-1.4-1.3-2-2 c0,0.7,0,1.5,0,2.2c0.5,6.1,1,12.2,1.6,18.3c0.4,0,0.8,0,1.2,0C30.9,53.8,30.9,55,30.9,56.2z"
  })), _ellipse27 || (_ellipse27 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st1rsh",
    cx: 32.4,
    cy: 51.9,
    rx: 0.8,
    ry: 0.9
  })), _ellipse28 || (_ellipse28 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st1rsh",
    cx: 9,
    cy: 51.2,
    rx: 0.7,
    ry: 0.9
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st12rsh",
    d: "M30.8,49.7c-4-0.3-8.2-0.5-12.6-0.5c-4.7-0.1-9.3,0-13.6,0.3c0.8-5.3,1.7-10.5,2.5-15.8 C7.1,32.4,7,31.2,6.9,30c0-0.1,0-0.4,0.2-0.8C7.2,29,7.6,28.8,8,28.9c6.5,0,13.1,0,19.6,0c0.3,0,0.4,0.1,0.5,0.2 c0.3,0.4,0.2,1.1,0.2,1.1l0,0c0,0,0,1.3,0,3.9C29.2,39.3,30,44.5,30.8,49.7z"
  })), _ellipse29 || (_ellipse29 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st13rsh",
    cx: 22.1,
    cy: 31.2,
    rx: 1.7,
    ry: 1.9
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "23.3,30 23.2,29.9 21.4,32.9 21.5,33 "
  })), _ellipse30 || (_ellipse30 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st14rsh",
    cx: 18.2,
    cy: 32.4,
    rx: 1.1,
    ry: 1.2
  })), _ellipse31 || (_ellipse31 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st14rsh",
    cx: 10.3,
    cy: 32.4,
    rx: 1.1,
    ry: 1.2
  })), _ellipse32 || (_ellipse32 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st14rsh",
    cx: 25.5,
    cy: 32.4,
    rx: 1.1,
    ry: 1.2
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st12rsh",
    d: "M31,52.7c0,1.3-0.1,2.5-0.1,3.8c-4.1-0.1-8.3-0.2-12.5-0.2c-4.8,0-9.5,0.1-14,0.3c0-1.3,0.1-2.5,0.1-3.8 C13.4,52.7,22.2,52.7,31,52.7z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st10rsh",
    d: "M17.1,56.2c0.8,0,1.5,0,2.3,0c-0.1-7.4-0.3-14.9-0.4-22.3c-0.6,0-1.2,0-1.9,0C17.1,41.3,17.1,48.8,17.1,56.2z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st15rsh",
    d: "M29.6,56.4c-0.5,0-1,0-1.5,0c0.4-0.4,0.8-0.8,1.2-1.2c0.3,0,0.6,0,0.8,0C30,55.5,29.8,55.9,29.6,56.4z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st16rsh",
    d: "M30.1,55.1c-0.3,0-0.6,0-0.8,0c-1-7.2-2-14.3-3-21.5c0.3,0.1,0.7,0.2,1,0.3C28.2,41,29.2,48.1,30.1,55.1z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st17rsh",
    d: "M25,32.1c0.3,0,0.6,0,0.9-0.1c0.5,0.6,0.9,1.3,1.4,1.9c-0.3-0.1-0.7-0.2-1-0.3C25.9,33.1,25.4,32.6,25,32.1z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st18rsh",
    d: "M26.7,56.2c0.5,0,0.9,0.1,1.4,0.1c0.4-0.4,0.8-0.8,1.2-1.2c-0.9-7.1-1.9-14.2-2.8-21.3c-0.5-0.6-1-1.1-1.5-1.7 c-0.1,0-0.2,0-0.3,0c0.7,5.7,1.3,11.5,2,17.2c-0.8,0-1.7,0-2.5,0c0,1.1,0,2.3,0.1,3.4c0.8,0,1.7,0,2.5,0 C26.7,53.9,26.7,55.1,26.7,56.2z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st19rsh",
    d: "M19,55C19,55,18.9,55,19,55c-0.4,0-1,0-1.3,0c0-7-0.1-14.1-0.1-21.1c0.5,0,0.9,0,1.4,0 C18.9,40.9,18.9,48,19,55z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st20rsh",
    d: "M19.4,56.2c-0.2-0.4-0.3-0.8-0.5-1.2c-0.4,0-0.9,0-1.3,0c-0.2,0.4-0.4,0.8-0.6,1.2 C17.9,56.2,18.7,56.2,19.4,56.2z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st21rsh",
    d: "M18.8,31.7c-0.4,0-0.9,0-1.3,0c-0.1,0.7-0.2,1.5-0.3,2.2c0.6,0,1.2,0,1.9,0C18.9,33.2,18.9,32.4,18.8,31.7z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st10rsh",
    d: "M9.5,56.1c-0.5,0-1,0-1.4,0c-0.3-0.4-0.7-0.8-1-1.2c0.9-7,1.8-14,2.6-21c0.4-0.6,0.9-1.1,1.3-1.7 c-0.4,5.7-0.9,11.3-1.3,17c0.7,0,1.3,0,2,0c-0.1,1.2-0.2,2.4-0.3,3.6c-0.6,0-1.3,0-1.9,0C9.5,53.9,9.5,55,9.5,56.1z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st0rsh",
    d: "M1.4,56.2c-0.5-0.9-0.9-1.7-1.4-2.6C1,46.7,1.9,39.9,2.9,33c0.5-0.2,0.9-0.5,1.4-0.7c1.3,0.6,2.5,1.2,3.8,1.9 c-0.4,2.2-0.8,4.4-1.2,6.6c-0.7-0.2-1.3-0.4-2-0.6c-0.1,0-0.8,0-1.1,0.6c-0.4,0.6-0.1,1.7,0.7,2.3C3.5,47.4,2.4,51.8,1.4,56.2z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st19rsh",
    d: "M6.1,55c0.3,0,0.7-0.1,1-0.1c0.9-7,1.8-14,2.6-21c-0.3,0-0.6,0-0.9,0C7.9,41,7,48,6.1,55z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st21rsh",
    d: "M9.7,33.9c-0.3,0-0.6,0-0.9,0c0.4-0.6,0.8-1.2,1.2-1.9c0.4,0.1,0.7,0.1,1.1,0.2C10.6,32.8,10.1,33.4,9.7,33.9z "
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st20rsh",
    d: "M6.6,56.3c-0.2-0.4-0.3-0.8-0.5-1.3c0.3,0,0.7-0.1,1-0.1c0.3,0.4,0.7,0.8,1,1.2C7.6,56.2,7.1,56.3,6.6,56.3z"
  })), _ellipse33 || (_ellipse33 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st1rsh",
    cx: 27.3,
    cy: 51.2,
    rx: 0.8,
    ry: 0.9
  })), _ellipse34 || (_ellipse34 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st1rsh",
    cx: 9,
    cy: 51.2,
    rx: 0.8,
    ry: 0.9
  })), _ellipse35 || (_ellipse35 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st1rsh",
    cx: 4.1,
    cy: 37.7,
    rx: 0.8,
    ry: 0.9
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 9.2,
    y: 26.9,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 35.9633 55.7349)",
    className: "st0rsh",
    width: 17.5,
    height: 2
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st22rsh",
    d: "M7.5,123.8c-0.1,0.1-0.2,0.4-0.3,0.8c-0.1,0.6,0.2,1,0.2,1.1c0.1,0.4,0.2,1.1,0,1.9c-0.1,0.4-0.2,0.7-0.4,0.9 c0,0.1,0,0.2,0,0.4c0,0,0.1,0.2,0.2,0.3c0.3,0.3,0.7,0,1.3,0.1c0.5,0,0.4,0.2,0.9,0.2c0.7,0,0.8-0.4,1.4-0.3 c0.6,0.1,0.6,0.5,1.1,0.5c0.6,0,0.7-0.5,1.3-0.4c0.4,0,0.4,0.3,0.9,0.5c0.6,0.2,0.9-0.3,1.7-0.4c0.7-0.1,0.7,0.3,1.5,0.3 c0.9,0,0.9-0.4,1.8-0.4c0.9,0,1,0.5,1.7,0.4c0.8-0.1,0.9-0.6,1.7-0.7c0.8-0.1,0.9,0.4,1.8,0.3c1-0.1,0.9-0.7,1.9-0.8 c0.8-0.1,1.1,0.3,2,0.2c0.4-0.1,0.8-0.3,1-0.4c0.4-0.5,0.5-0.9,0.5-1.2c0-0.6-0.3-1.4-0.3-1.4l0,0c0,0,0-0.5,0-1.3 c0.1-0.1,0.2-0.3,0.2-0.7c0-0.5-0.2-0.8-0.3-0.9c-7.3,0-14.6,0-21.9,0C7.4,123.2,7.4,123.5,7.5,123.8z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "st23rsh",
    d: "M7.4,118.8c-0.1,0.1-0.2,0.4-0.3,0.8c-0.1,0.6,0.2,1,0.2,1.1c0.1,0.4,0.2,1.1,0,1.9c-0.1,0.4-0.2,0.7-0.4,0.9 c0,0.1,0,0.2,0,0.4c0,0,0.1,0.2,0.2,0.3c0.3,0.3,0.7,0,1.3,0.1c0.5,0,0.4,0.2,0.9,0.2c0.7,0,0.8-0.4,1.4-0.3 c0.6,0.1,0.6,0.5,1.1,0.5c0.6,0,0.7-0.5,1.3-0.4c0.4,0,0.4,0.3,0.9,0.5c0.6,0.2,0.9-0.3,1.7-0.4c0.7-0.1,0.7,0.3,1.5,0.3 c0.9,0,0.9-0.4,1.8-0.4c0.9,0,1,0.5,1.7,0.4c0.8-0.1,0.9-0.6,1.7-0.7c0.8-0.1,0.9,0.4,1.8,0.3c1-0.1,0.9-0.7,1.9-0.8 c0.8-0.1,1.1,0.3,2,0.2c0.4-0.1,0.8-0.3,1-0.4c0.4-0.5,0.5-0.9,0.5-1.2c0-0.6-0.3-1.4-0.3-1.4l0,0c0,0,0-0.5,0-1.3 c0.1-0.1,0.2-0.3,0.2-0.7c0-0.5-0.2-0.8-0.3-0.9c-7.3,0-14.6,0-21.9,0C7.4,118.1,7.4,118.4,7.4,118.8z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "st22rsh",
    d: "M7.4,114.8c-0.1,0.1-0.2,0.4-0.3,0.8c-0.1,0.6,0.2,1,0.2,1.1c0.1,0.4,0.2,1.1,0,1.9c-0.1,0.4-0.2,0.7-0.4,0.9 c0,0.1,0,0.2,0,0.4c0,0,0.1,0.2,0.2,0.3c0.3,0.3,0.7,0,1.3,0.1c0.5,0,0.4,0.2,0.9,0.2c0.7,0,0.8-0.4,1.4-0.3 c0.6,0.1,0.6,0.5,1.1,0.5c0.6,0,0.7-0.5,1.3-0.4c0.4,0,0.4,0.3,0.9,0.5c0.6,0.2,0.9-0.3,1.7-0.4c0.7-0.1,0.7,0.3,1.5,0.3 c0.9,0,0.9-0.4,1.8-0.4c0.9,0,1,0.5,1.7,0.4c0.8-0.1,0.9-0.6,1.7-0.7c0.8-0.1,0.9,0.4,1.8,0.3c1-0.1,0.9-0.7,1.9-0.8 c0.8-0.1,1.1,0.3,2,0.2c0.4-0.1,0.8-0.3,1-0.4c0.4-0.5,0.5-0.9,0.5-1.2c0-0.6-0.3-1.4-0.3-1.4l0,0c0,0,0-0.5,0-1.3 c0.1-0.1,0.2-0.3,0.2-0.7c0-0.5-0.2-0.8-0.3-0.9c-7.3,0-14.6,0-21.9,0C7.4,114.1,7.4,114.4,7.4,114.8z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "st23rsh",
    d: "M7.4,110.1c-0.1,0.1-0.2,0.4-0.3,0.8c-0.1,0.6,0.2,1,0.2,1.1c0.1,0.4,0.2,1.1,0,1.9c-0.1,0.4-0.2,0.7-0.4,0.9 c0,0.1,0,0.2,0,0.4c0,0,0.1,0.2,0.2,0.3c0.3,0.3,0.7,0,1.3,0.1c0.5,0,0.4,0.2,0.9,0.2c0.7,0,0.8-0.4,1.4-0.3 c0.6,0.1,0.6,0.5,1.1,0.5c0.6,0,0.7-0.5,1.3-0.4c0.4,0,0.4,0.3,0.9,0.5c0.6,0.2,0.9-0.3,1.7-0.4c0.7-0.1,0.7,0.3,1.5,0.3 c0.9,0,0.9-0.4,1.8-0.4c0.9,0,1,0.5,1.7,0.4c0.8-0.1,0.9-0.6,1.7-0.7c0.8-0.1,0.9,0.4,1.8,0.3c1-0.1,0.9-0.7,1.9-0.8 c0.8-0.1,1.1,0.3,2,0.2c0.4-0.1,0.8-0.3,1-0.4c0.4-0.5,0.5-0.9,0.5-1.2c0-0.6-0.3-1.4-0.3-1.4l0,0c0,0,0-0.5,0-1.3 c0.1-0.1,0.2-0.3,0.2-0.7c0-0.5-0.2-0.8-0.3-0.9c-7.3,0-14.6,0-21.9,0C7.4,109.5,7.4,109.8,7.4,110.1z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "st22rsh",
    d: "M7.5,105.8c-0.1,0.1-0.2,0.4-0.3,0.8c-0.1,0.6,0.2,1,0.2,1.1c0.1,0.4,0.2,1.1,0,1.9c-0.1,0.4-0.2,0.7-0.4,0.9 c0,0.1,0,0.2,0,0.4c0,0,0.1,0.2,0.2,0.3c0.3,0.3,0.7,0,1.3,0.1c0.5,0,0.4,0.2,0.9,0.2c0.7,0,0.8-0.4,1.4-0.3 c0.6,0.1,0.6,0.5,1.1,0.5c0.6,0,0.7-0.5,1.3-0.4c0.4,0,0.4,0.3,0.9,0.5c0.6,0.2,0.9-0.3,1.7-0.4c0.7-0.1,0.7,0.3,1.5,0.3 c0.9,0,0.9-0.4,1.8-0.4c0.9,0,1,0.5,1.7,0.4c0.8-0.1,0.9-0.6,1.7-0.7c0.8-0.1,0.9,0.4,1.8,0.3c1-0.1,0.9-0.7,1.9-0.8 c0.8-0.1,1.1,0.3,2,0.2c0.4-0.1,0.8-0.3,1-0.4c0.4-0.5,0.5-0.9,0.5-1.2c0-0.6-0.3-1.4-0.3-1.4l0,0c0,0,0-0.5,0-1.3 c0.1-0.1,0.2-0.3,0.2-0.7c0-0.5-0.2-0.8-0.3-0.9c-7.3,0-14.6,0-21.9,0C7.4,105.1,7.4,105.5,7.5,105.8z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "st23rsh",
    d: "M7.4,100.5c-0.1,0.1-0.2,0.4-0.3,0.8c-0.1,0.6,0.2,1,0.2,1.1c0.1,0.4,0.2,1.1,0,1.9c-0.1,0.4-0.2,0.7-0.4,0.9 c0,0.1,0,0.2,0,0.4c0,0,0.1,0.2,0.2,0.3c0.3,0.3,0.7,0,1.3,0.1c0.5,0,0.4,0.2,0.9,0.2c0.7,0,0.8-0.4,1.4-0.3 c0.6,0.1,0.6,0.5,1.1,0.5c0.6,0,0.7-0.5,1.3-0.4c0.4,0,0.4,0.3,0.9,0.5c0.6,0.2,0.9-0.3,1.7-0.4c0.7-0.1,0.7,0.3,1.5,0.3 c0.9,0,0.9-0.4,1.8-0.4c0.9,0,1,0.5,1.7,0.4c0.8-0.1,0.9-0.6,1.7-0.7c0.8-0.1,0.9,0.4,1.8,0.3c1-0.1,0.9-0.7,1.9-0.8 c0.8-0.1,1.1,0.3,2,0.2c0.4-0.1,0.8-0.3,1-0.4c0.4-0.5,0.5-0.9,0.5-1.2c0-0.6-0.3-1.4-0.3-1.4l0,0c0,0,0-0.5,0-1.3 c0.1-0.1,0.2-0.3,0.2-0.7c0-0.5-0.2-0.8-0.3-0.9c-7.3,0-14.6,0-21.9,0C7.4,99.8,7.4,100.1,7.4,100.5z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "st22rsh",
    d: "M7.5,97c-0.1,0.1-0.2,0.4-0.3,0.8c-0.1,0.6,0.2,1,0.2,1.1c0.1,0.4,0.2,1.1,0,1.9c-0.1,0.4-0.2,0.7-0.4,0.9 c0,0.1,0,0.2,0,0.4c0,0,0.1,0.2,0.2,0.3c0.3,0.3,0.7,0,1.3,0.1c0.5,0,0.4,0.2,0.9,0.2c0.7,0,0.8-0.4,1.4-0.3 c0.6,0.1,0.6,0.5,1.1,0.5c0.6,0,0.7-0.5,1.3-0.4c0.4,0,0.4,0.3,0.9,0.5c0.6,0.2,0.9-0.3,1.7-0.4c0.7-0.1,0.7,0.3,1.5,0.3 c0.9,0,0.9-0.4,1.8-0.4c0.9,0,1,0.5,1.7,0.4c0.8-0.1,0.9-0.6,1.7-0.7c0.8-0.1,0.9,0.4,1.8,0.3c1-0.1,0.9-0.7,1.9-0.8 c0.8-0.1,1.1,0.3,2,0.2c0.4-0.1,0.8-0.3,1-0.4c0.4-0.5,0.5-0.9,0.5-1.2c0-0.6-0.3-1.4-0.3-1.4l0,0c0,0,0-0.5,0-1.3 c0.1-0.1,0.2-0.3,0.2-0.7c0-0.5-0.2-0.8-0.3-0.9c-7.3,0-14.6,0-21.9,0C7.4,96.3,7.4,96.7,7.5,97z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "st22rsh",
    d: "M29.4,100.1c0.1-0.1,0.2-0.4,0.3-0.8c0.1-0.6-0.2-1-0.2-1.1c-0.1-0.4-0.2-1.1,0-1.9c0.1-0.4,0.2-0.7,0.3-0.9 c0-0.1,0-0.2,0-0.4c0,0-0.1-0.2-0.2-0.3c-0.3-0.3-0.7,0-1.3-0.1c-0.5,0-0.4-0.2-0.9-0.2c-0.7,0-0.8,0.4-1.4,0.3 c-0.6-0.1-0.6-0.5-1.1-0.5c-0.6,0-0.7,0.5-1.2,0.4c-0.4,0-0.4-0.3-0.8-0.5c-0.6-0.2-0.9,0.3-1.7,0.4c-0.7,0.1-0.7-0.3-1.5-0.3 c-0.8,0-0.9,0.4-1.7,0.4c-0.9,0-1-0.5-1.7-0.4c-0.8,0.1-0.8,0.6-1.7,0.7c-0.8,0.1-0.9-0.4-1.7-0.3c-0.9,0.1-0.9,0.7-1.9,0.8 c-0.8,0.1-1.1-0.3-1.9-0.2c-0.4,0.1-0.8,0.3-1,0.4c-0.4,0.5-0.5,0.9-0.5,1.2c0,0.6,0.3,1.4,0.3,1.4l0,0c0,0,0,0.5,0,1.3 c-0.1,0.1-0.2,0.3-0.2,0.7c0,0.5,0.2,0.8,0.3,0.9c7.1,0,14.2,0,21.4,0C29.4,100.7,29.4,100.4,29.4,100.1z"
  })), _ellipse36 || (_ellipse36 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st24rsh",
    cx: 8,
    cy: 199.1,
    rx: 0.5,
    ry: 0.6
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "st24rsh",
    d: "M12.9,199.8H8.9c0-0.1-0.1-0.3-0.1-0.5c0-0.2,0.1-0.3,0.1-0.4c1.3,0,2.6,0,3.9,0c0,0,0.2,0.2,0.2,0.5 C13,199.6,12.9,199.8,12.9,199.8z"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 9.3,
    y: 198.5,
    className: "st24rsh",
    width: 3.5,
    height: 0.5
  })), _ellipse37 || (_ellipse37 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st24rsh",
    cx: 29.1,
    cy: 199,
    rx: 0.5,
    ry: 0.6
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "st24rsh",
    d: "M27.9,199.8H24c0-0.1-0.1-0.3-0.1-0.5c0-0.2,0.1-0.3,0.1-0.4c1.3,0,2.6,0,3.9,0c0,0,0.2,0.2,0.2,0.5 C28.1,199.6,27.9,199.8,27.9,199.8z"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 24.4,
    y: 198.5,
    className: "st24rsh",
    width: 3.5,
    height: 0.5
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 15.5,
    y: 199.1,
    className: "st24rsh",
    width: 5.4,
    height: 0.9
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 14.8,
    y: 198.3,
    className: "st25rsh",
    width: 6.9,
    height: 1.6
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 14.3,
    y: 198.3,
    className: "st26rsh",
    width: 0.5,
    height: 1.7
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 21.7,
    y: 198.3,
    className: "st26rsh",
    width: 0.7,
    height: 1.6
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 4.3,
    y: 154.8,
    className: "st0rsh",
    width: 28.8,
    height: 3.7
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "st27rsh",
    d: "M33.3,152.6H4c-0.2,0-0.4-0.2-0.4-0.4V147c0-0.2,0.2-0.4,0.4-0.4h29.3c0.2,0,0.4,0.2,0.4,0.4v5.3 C33.7,152.5,33.5,152.6,33.3,152.6z"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 9.5,
    y: 152.6,
    className: "st0rsh",
    width: 18.3,
    height: 2.7
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2rsh",
    d: "M6.8,154.2c-0.6,0-1,0.3-1,0.6h2C7.8,154.5,7.3,154.2,6.8,154.2z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2rsh",
    d: "M13,154.2c-0.6,0-1,0.3-1,0.6h2C14,154.5,13.6,154.2,13,154.2z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2rsh",
    d: "M23.1,154.2c-0.6,0-1,0.3-1,0.6h2C24.1,154.4,23.6,154.2,23.1,154.2z"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2rsh",
    d: "M30.3,154.2c-0.6,0-1,0.3-1,0.6h2C31.4,154.4,30.9,154.2,30.3,154.2z"
  }))), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 6.1,
    y: 146.6,
    className: "st28rsh",
    width: 0.6,
    height: 6.1
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 17.8,
    y: 146.6,
    className: "st28rsh",
    width: 0.6,
    height: 6.1
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 20.1,
    y: 146.6,
    className: "st28rsh",
    width: 0.6,
    height: 6.1
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 23.1,
    y: 146.6,
    className: "st28rsh",
    width: 0.6,
    height: 6.1
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "st28rsh",
    d: "M33.4,152.6L33.4,152.6c-0.2,0-0.3-0.1-0.3-0.3v-5.4c0-0.2,0.1-0.3,0.3-0.3l0,0c0.2,0,0.3,0.1,0.3,0.3v5.4 C33.7,152.5,33.6,152.6,33.4,152.6z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "st0rsh",
    d: "M31.7,157.6c0.7-0.1,1.5-0.1,2.2-0.2c0.4,0.4,0.7,0.9,1.1,1.3c-1.3,7-2.6,14.1-4,21.1c-0.7,0.7-1.4,1.3-2,2 c0-0.7,0-1.5,0-2.2c0.5-6.1,1-12.2,1.6-18.3c0.4,0,0.8,0,1.2,0C31.7,160.1,31.7,158.8,31.7,157.6z"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 6.3,
    y: 161.1,
    className: "st10rsh",
    width: 24.3,
    height: 4.5
  })), _ellipse38 || (_ellipse38 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st11rsh",
    cx: 13.7,
    cy: 161.8,
    rx: 1.3,
    ry: 0.2
  })), _ellipse39 || (_ellipse39 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st11rsh",
    cx: 13.7,
    cy: 162.3,
    rx: 1.3,
    ry: 0.2
  })), _ellipse40 || (_ellipse40 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st11rsh",
    cx: 13.7,
    cy: 162.8,
    rx: 1.3,
    ry: 0.2
  })), _ellipse41 || (_ellipse41 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st11rsh",
    cx: 13.7,
    cy: 163.3,
    rx: 1.3,
    ry: 0.2
  })), _ellipse42 || (_ellipse42 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st11rsh",
    cx: 13.7,
    cy: 163.8,
    rx: 1.3,
    ry: 0.2
  })), _ellipse43 || (_ellipse43 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st11rsh",
    cx: 13.7,
    cy: 164.2,
    rx: 1.3,
    ry: 0.2
  })), _ellipse44 || (_ellipse44 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st11rsh",
    cx: 13.7,
    cy: 164.8,
    rx: 1.3,
    ry: 0.2
  })), _ellipse45 || (_ellipse45 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st11rsh",
    cx: 22.7,
    cy: 161.8,
    rx: 1.3,
    ry: 0.2
  })), _ellipse46 || (_ellipse46 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st11rsh",
    cx: 22.7,
    cy: 162.4,
    rx: 1.3,
    ry: 0.2
  })), _ellipse47 || (_ellipse47 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st11rsh",
    cx: 22.7,
    cy: 162.8,
    rx: 1.3,
    ry: 0.2
  })), _ellipse48 || (_ellipse48 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st11rsh",
    cx: 22.7,
    cy: 163.3,
    rx: 1.3,
    ry: 0.2
  })), _ellipse49 || (_ellipse49 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st11rsh",
    cx: 22.7,
    cy: 163.8,
    rx: 1.3,
    ry: 0.2
  })), _ellipse50 || (_ellipse50 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st11rsh",
    cx: 22.7,
    cy: 164.2,
    rx: 1.3,
    ry: 0.2
  })), _ellipse51 || (_ellipse51 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st11rsh",
    cx: 22.7,
    cy: 164.8,
    rx: 1.3,
    ry: 0.2
  })), _ellipse52 || (_ellipse52 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st11rsh",
    cx: 29.5,
    cy: 161.9,
    rx: 1.3,
    ry: 0.2
  })), _ellipse53 || (_ellipse53 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st11rsh",
    cx: 29.5,
    cy: 162.4,
    rx: 1.3,
    ry: 0.2
  })), _ellipse54 || (_ellipse54 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st11rsh",
    cx: 29.5,
    cy: 162.9,
    rx: 1.3,
    ry: 0.2
  })), _ellipse55 || (_ellipse55 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st11rsh",
    cx: 29.5,
    cy: 163.3,
    rx: 1.3,
    ry: 0.2
  })), _ellipse56 || (_ellipse56 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st11rsh",
    cx: 29.5,
    cy: 163.8,
    rx: 1.3,
    ry: 0.2
  })), _ellipse57 || (_ellipse57 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st11rsh",
    cx: 29.5,
    cy: 164.3,
    rx: 1.3,
    ry: 0.2
  })), _ellipse58 || (_ellipse58 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st11rsh",
    cx: 29.5,
    cy: 164.8,
    rx: 1.3,
    ry: 0.2
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "st0rsh",
    d: "M5.4,158c-0.7-0.1-1.5-0.1-2.2-0.2c-0.4,0.4-0.7,0.9-1.1,1.3c1.3,7,2.6,14.1,4,21.1c0.7,0.7,1.4,1.3,2,2 c0-0.7,0-1.5,0-2.2c-0.5-6.1-1-12.2-1.6-18.3c-0.4,0-0.8,0-1.2,0C5.3,160.5,5.3,159.3,5.4,158z"
  })), _ellipse59 || (_ellipse59 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st1rsh",
    cx: 4.8,
    cy: 162.7,
    rx: 0.8,
    ry: 0.9
  })), _ellipse60 || (_ellipse60 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st1rsh",
    cx: 27.3,
    cy: 163,
    rx: 0.7,
    ry: 0.9
  })), _ellipse61 || (_ellipse61 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st1rsh",
    cx: 32.3,
    cy: 162.9,
    rx: 0.8,
    ry: 0.9
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "st12rsh",
    d: "M5.5,164.6c4,0.3,8.2,0.5,12.6,0.5c4.7,0.1,9.3,0,13.6-0.3c-0.8,5.3-1.7,10.5-2.5,15.8 c0.1,1.2,0.2,2.4,0.3,3.6c0,0.1,0,0.4-0.2,0.8c-0.2,0.3-0.6,0.5-0.9,0.4c-6.5,0-13.1,0-19.6,0c-0.3,0-0.4-0.1-0.5-0.2 c-0.3-0.4-0.2-1.1-0.2-1.1l0,0c0,0,0-1.3,0-3.9C7.1,174.9,6.3,169.7,5.5,164.6z"
  })), _ellipse62 || (_ellipse62 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st13rsh",
    cx: 14.2,
    cy: 183,
    rx: 1.7,
    ry: 1.9
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "13,184.3 13.1,184.4 14.9,181.3 14.8,181.2 "
  })), _ellipse63 || (_ellipse63 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st14rsh",
    cx: 18.1,
    cy: 181.8,
    rx: 1.1,
    ry: 1.2
  })), _ellipse64 || (_ellipse64 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st14rsh",
    cx: 26,
    cy: 181.8,
    rx: 1.1,
    ry: 1.2
  })), _ellipse65 || (_ellipse65 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st14rsh",
    cx: 10.8,
    cy: 181.8,
    rx: 1.1,
    ry: 1.2
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "st12rsh",
    d: "M5.2,161.6c0-1.3,0.1-2.5,0.1-3.8c4.1,0.1,8.3,0.2,12.5,0.2c4.8,0,9.5-0.1,14-0.3c0,1.3-0.1,2.5-0.1,3.8 C22.9,161.5,14.1,161.5,5.2,161.6z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "st10rsh",
    d: "M19.1,158c-0.8,0-1.5,0-2.3,0c0.1,7.4,0.3,14.9,0.4,22.3c0.6,0,1.2,0,1.9,0C19.1,172.9,19.1,165.5,19.1,158z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "st15rsh",
    d: "M6.6,157.9c0.5,0,1,0,1.5,0c-0.4,0.4-0.8,0.8-1.2,1.2c-0.3,0-0.6,0-0.8,0C6.3,158.7,6.5,158.3,6.6,157.9z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "st16rsh",
    d: "M6.1,159.1c0.3,0,0.6,0,0.8,0c1,7.2,2,14.3,3,21.5c-0.3-0.1-0.7-0.2-1-0.3C8,173.2,7.1,166.2,6.1,159.1z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "st17rsh",
    d: "M11.2,182.1c-0.3,0-0.6,0-0.9,0.1c-0.5-0.6-0.9-1.3-1.4-1.9c0.3,0.1,0.7,0.2,1,0.3 C10.4,181.1,10.8,181.6,11.2,182.1z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "st18rsh",
    d: "M9.5,158c-0.5,0-0.9-0.1-1.4-0.1c-0.4,0.4-0.8,0.8-1.2,1.2c0.9,7.1,1.9,14.2,2.8,21.3c0.5,0.6,1,1.1,1.5,1.7 c0.1,0,0.2,0,0.3,0c-0.7-5.7-1.3-11.5-2-17.2c0.8,0,1.7,0,2.5,0c0-1.1,0-2.3-0.1-3.4c-0.8,0-1.7,0-2.5,0 C9.5,160.3,9.5,159.2,9.5,158z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "st19rsh",
    d: "M17.3,159.2C17.3,159.2,17.3,159.2,17.3,159.2c0.4,0,1,0,1.3,0c0,7,0.1,14.1,0.1,21.1c-0.5,0-0.9,0-1.4,0 C17.3,173.3,17.3,166.3,17.3,159.2z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "st20rsh",
    d: "M16.8,158c0.2,0.4,0.3,0.8,0.5,1.2c0.4,0,0.9,0,1.3,0c0.2-0.4,0.4-0.8,0.6-1.2C18.4,158,17.6,158,16.8,158z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "st21rsh",
    d: "M17.4,182.5c0.4,0,0.9,0,1.3,0c0.1-0.7,0.2-1.5,0.3-2.2c-0.6,0-1.2,0-1.9,0C17.3,181.1,17.4,181.8,17.4,182.5z "
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "st10rsh",
    d: "M26.8,158.1c0.5,0,1,0,1.4,0c0.3,0.4,0.7,0.8,1,1.2c-0.9,7-1.8,14-2.6,21c-0.4,0.6-0.9,1.1-1.3,1.7 c0.4-5.7,0.9-11.3,1.3-17c-0.7,0-1.3,0-2,0c0.1-1.2,0.2-2.4,0.3-3.6c0.6,0,1.3,0,1.9,0C26.8,160.4,26.8,159.2,26.8,158.1z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "st19rsh",
    d: "M30.2,159.2c-0.3,0-0.7,0.1-1,0.1c-0.9,7-1.8,14-2.6,21c0.3,0,0.6,0,0.9,0C28.4,173.3,29.3,166.2,30.2,159.2z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "st21rsh",
    d: "M26.6,180.3c0.3,0,0.6,0,0.9,0c-0.4,0.6-0.8,1.2-1.2,1.9c-0.4-0.1-0.7-0.1-1.1-0.2 C25.7,181.4,26.1,180.9,26.6,180.3z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "st20rsh",
    d: "M29.7,157.9c0.2,0.4,0.3,0.8,0.5,1.3c-0.3,0-0.7,0.1-1,0.1c-0.3-0.4-0.7-0.8-1-1.2 C28.7,158,29.2,158,29.7,157.9z"
  })), _ellipse66 || (_ellipse66 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st1rsh",
    cx: 9,
    cy: 163,
    rx: 0.8,
    ry: 0.9
  })), _ellipse67 || (_ellipse67 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st1rsh",
    cx: 27.3,
    cy: 163,
    rx: 0.8,
    ry: 0.9
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 9.4,
    y: 185.3,
    className: "st12rsh",
    width: 18.6,
    height: 1.3
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "st29rsh",
    d: "M6.4,192.4c0-1.5,0-3,0-4.4c0.1-0.3,0.3-0.7,0.6-1.1c0.9-0.9,2.2-0.5,2.3-0.5c6.3,0,12.5,0,18.8,0 c1-0.2,2,0.1,2.5,0.9c0.3,0.5,0.3,0.9,0.3,1.2c0,1.4,0,2.8,0,4.2C22.7,192.6,14.5,192.5,6.4,192.4z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "st30rsh",
    d: "M12.6,192.3c-0.1,0.5-0.2,1-0.3,1.5c0,0-0.2,0-0.2,0c-0.4,0-6.6-0.3-7-0.3c0.4-0.5,0.7-1,1.1-1.5 C8.3,192.1,10.5,192.2,12.6,192.3z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "st16rsh",
    d: "M12.6,192.3c-0.1,0.4-0.3,0.8-0.4,1.2c3.6,0,7.2,0,10.7,0c0.1-0.4,0.3-0.9,0.4-1.3 C19.7,192.3,16.2,192.3,12.6,192.3z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "st31rsh",
    d: "M31.4,192c0.2,0.4,0.5,0.7,0.7,1.1c-3.1,0.2-6.2,0.3-9.3,0.5c0.1-0.4,0.3-0.9,0.4-1.3 C26,192.2,28.7,192.1,31.4,192z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "st32rsh",
    d: "M12.5,198.6c0-1.7,0-3.4,0-5.1c-2.5,0-4.9-0.1-7.4-0.1c0,1.4,0,2.9,0,4.3c0.2,0.2,0.3,0.5,0.5,0.7 C7.9,198.5,10.2,198.5,12.5,198.6z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "st29rsh",
    d: "M23.5,198.6c-3.8,0-7.6,0-11.3,0c0-1.7,0-3.4,0-5.1c3.8,0,7.5,0,11.3,0C23.5,195.2,23.5,196.9,23.5,198.6z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "st30rsh",
    d: "M32.1,197.3c-0.3,0.4-0.6,0.8-0.9,1.2c-2.8,0-5.5,0.1-8.3,0.1c0-1.7,0-3.3,0-5c3.1-0.2,6.1-0.4,9.2-0.6 C32.1,194.4,32.1,195.9,32.1,197.3z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReyHilt);
export default __webpack_public_path__ + "static/media/rey-hilt.fe2f4be7.svg";
export { ForwardRef as ReactComponent };